export enum Selection {
    Company = 'company',
    Reseller = 'reseller',
    Location = 'location',
    Employee = 'employee',
    System = 'system',
    SystemSettings = 'system-settings',
}

export type FilterInput = {
    companies: { [key: string]: boolean };
    resellers: { [key: string]: boolean };
    locations: { [key: string]: boolean };
};
